import { traceError } from './utils/trace-error';

const maxRetries = 3;

const storageKey = 'import-error-retries';
const retryResetMs = 30_000;

let isReloading = false;

export const handleImportError = () => {
  window.setTimeout(() => sessionStorage.removeItem(storageKey), retryResetMs);

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();

    if (isReloading) {
      return;
    }

    const errRetries: string | null = sessionStorage.getItem(storageKey);

    if (typeof errRetries === 'string') {
      const retries = parseInt(errRetries);

      if (retries >= maxRetries) {
        traceError(new Error('Error during page load'));
        return;
      }

      sessionStorage.setItem(storageKey, String(retries + 1));
    } else {
      sessionStorage.setItem(storageKey, '1');
    }

    isReloading = true;
    console.warn('Error during module load. Reloading...');
    window.location.reload();
  });
};
